import React, { useState, useCallback, useRef, useEffect } from 'react';
import Webcam from 'react-webcam';
import { Stack, Button, Select, MenuItem, FormControl, InputLabel, IconButton, Card } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import Loading from './Loading';
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import CameraswitchIcon from '@mui/icons-material/Cameraswitch';

const PhotoCapture = ({ onCapture }) => {
  const { t } = useTranslation();
  const [frontCamera, setFrontCamera] = useState(!isMobile);
  const webcamRef = useRef(null);
  const [devices, setDevices] = useState([]);
  const [deviceId, setDeviceId] = useState(null);
  const [isCapturing, setIsCapturing] = useState(false);
  const [videoConstraints, setVideoConstraints] = useState({
    width: frontCamera ? 1080 : 1920,
    height: frontCamera ? 1920 : 1080,
    facingMode: isMobile ? "environment" : "user"
  });
  const [currentDeviceIndex, setCurrentDeviceIndex] = useState(0);


  const handleDevices = useCallback(
    mediaDevices => {
      console.log(mediaDevices);
      const videoDevices = mediaDevices.filter(({ kind }) => kind === "videoinput");
      setDevices(videoDevices);
      if (deviceId == null) {
        let device = videoDevices[0];
        let capabilities = device.getCapabilities();
        console.log(capabilities);
        if (capabilities.facingMode == "environment") {
          setFrontCamera(true);
        } else {
          setFrontCamera(false);
        }
        setDeviceId(videoDevices[0].deviceId);
        setVideoConstraints({ ...videoConstraints, deviceId: videoDevices[0].deviceId });
      }
    },
    [deviceId]
  );

  React.useEffect(() => {
    navigator.mediaDevices.getUserMedia({ video: true }).then(x => {
    navigator.mediaDevices.enumerateDevices().then(handleDevices);
    });
    if (deviceId) {
      setVideoConstraints({ ...videoConstraints, deviceId: deviceId });
    }
  }, []);

  const changeDevice = () => {
    let newDeviceIndex = 0;
    if (currentDeviceIndex < devices.length - 1) {
      newDeviceIndex = currentDeviceIndex + 1;
    } else {
      newDeviceIndex = 0;
    }
    let device = devices[newDeviceIndex];
    let capabilities = device.getCapabilities();
    if (capabilities.facingMode == "environment") {
      setFrontCamera(true);
    } else {
      setFrontCamera(false);
    }
    setCurrentDeviceIndex(newDeviceIndex);
    setDeviceId(devices[newDeviceIndex].deviceId);
    setVideoConstraints({ ...videoConstraints, deviceId: devices[newDeviceIndex].deviceId });
  }

  const capture = useCallback(() => {
    setIsCapturing(true);
    const imageSrc = webcamRef.current.getScreenshot({ width: frontCamera ? 1080 : 1920, height: frontCamera ? 1920 : 1080 });
    if (onCapture) {
      const [, imageSrcB64] = imageSrc.split(",", 2);
      const bstr = atob(imageSrcB64);
      const u8arr = new Uint8Array(bstr.length);
      for (let i = 0; i < bstr.length; i++) {
        u8arr[i] = bstr.charCodeAt(i);
      }
      const imageBlob = new Blob([u8arr], { type: "image/jpeg" });
      onCapture(imageBlob);
    }
    setIsCapturing(false);
  }, [webcamRef, onCapture]);

  return (
    <Stack spacing={2} alignItems="center" justifyContent="center" style={{ width: '95%', marginTop: "-10vh" }}>
      {devices.length > 0 ? (
      <Card style={{ 
        backgroundColor: "#FFFFFF10", 
        padding: "16px", 
        borderRadius: "10px", 
        width: "100%"
      }}>
        <Stack spacing={2}>
          <Webcam
            audio={false}
            height={frontCamera ? 1920 : 1080}
            ref={webcamRef}
            mirrored={frontCamera == false}
            screenshotFormat="image/jpeg"
            width={frontCamera ? 1080 : 1920}
            videoConstraints={videoConstraints}
            style={{ width: '100%', height: "70vh", borderRadius: '8px', objectFit: "contain" }}
          />
          {devices.length > 1 && isMobile &&
            <IconButton  size="small" style={{position: "absolute", marginTop: "65vh", width: "fit-content", marginLeft: "75%", backgroundColor: '#000', color: '#FFF', '&:hover': {backgroundColor: '#f5f5f5'}}} onClick={changeDevice}>
              <CameraswitchIcon />
            </IconButton >
          }

          {devices.length > 1 && !isMobile &&

          <FormControl fullWidth>
            <InputLabel id="camera-select-label" style={{ color: 'white' }}>
              {t('selectCamera')}
            </InputLabel>
            <Select
              labelId="camera-select-label"
              value={deviceId}
              onChange={(e) => setDeviceId(e.target.value)}
              style={{ color: 'white', backgroundColor: '#FFFFFF10' }}
            >
              {devices.map((device, key) => (
                <MenuItem key={device.deviceId} value={device.deviceId}>
                  {device.label || `Camera ${key + 1}`}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          }

          <Button
            variant="contained"
            onClick={capture}
            disabled={isCapturing}
            startIcon={<CameraAltIcon />}
            style={{ 
              backgroundColor: 'white',
              color: 'black',
              '&:hover': {
                backgroundColor: '#f5f5f5'
              }
            }}
          >
            {isCapturing ? t('capturing') : t('capturePhoto')}
          </Button>

        </Stack>
      </Card>
      ) : (
        <Loading />
      )}
    </Stack>
  );
};

export default PhotoCapture; 